import { CloseCircle, TickCircle } from "iconsax-react";
import { MessageSquare } from "lucide-react";

import { AuthorizationStatusEnum } from "@/app/services/authorizationService/getAuthorization";
import masks from "@/app/utils/masks";

type AuthorizationStatusProps = {
  status?: AuthorizationStatusEnum;
  observation?: string;
  smsSent?: boolean;
  phone?: string;
};

export default function AuthorizationStatus({
  status,
  observation,
  smsSent,
  phone,
}: AuthorizationStatusProps) {
  return (
    <div className="flex flex-col gap-4">
      {status === AuthorizationStatusEnum.PENDING && (
        <div className="flex items-start gap-3 rounded-2xl border border-gray01 p-4">
          <MessageSquare className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
          <div className="flex flex-col gap-1">
            <strong className="text-sm font-semibold text-black01">
              {smsSent
                ? "Aguardando o cliente autorizar"
                : "Pré-análise em andamento"}
            </strong>
            <p className="text-sm text-black04">
              {smsSent
                ? `Enviamos um SMS para ${
                    phone ? masks.phone(phone) : "o telefone do cliente"
                  }. A consulta é liberada assim que ele responder.`
                : "A Crefaz está analisando o cadastro. Quando terminar, o SMS de autorização é enviado ao cliente — abra os detalhes da autorização para ver o andamento."}
            </p>
          </div>
        </div>
      )}

      {status === AuthorizationStatusEnum.AUTHORIZED && (
        <div className="flex items-start gap-3 rounded-2xl border border-gray01 p-4">
          <TickCircle variant="Bold" size={24} className="text-success" />
          <div className="flex flex-col gap-1">
            <strong className="text-sm font-semibold text-black01">
              Consulta autorizada
            </strong>
            <p className="text-sm text-black04">
              A renda e a tabela de juros já estão disponíveis para a simulação.
            </p>
          </div>
        </div>
      )}

      {status === AuthorizationStatusEnum.NO_OFFER && (
        <div className="flex items-start gap-3 rounded-2xl border border-gray01 p-4">
          <CloseCircle variant="Bold" size={24} className="text-error" />
          <div className="flex flex-col gap-1">
            <strong className="text-sm font-semibold text-black01">
              Sem oferta para este cliente
            </strong>
            <p className="text-sm text-black04">A Crefaz recusou a proposta.</p>
          </div>
        </div>
      )}

      {status === AuthorizationStatusEnum.COMPLETED && (
        <div className="flex items-start gap-3 rounded-2xl border border-gray01 p-4">
          <TickCircle variant="Bold" size={24} className="text-success" />
          <div className="flex flex-col gap-1">
            <strong className="text-sm font-semibold text-black01">
              Proposta concluída
            </strong>
            <p className="text-sm text-black04">
              Acompanhe o andamento pela lista de transações.
            </p>
          </div>
        </div>
      )}

      {observation && (
        <p className="text-sm text-black04">
          <strong className="font-semibold text-black01">Crefaz:</strong>{" "}
          {observation}
        </p>
      )}
    </div>
  );
}
